import {SUPPORTINGDOCUMENTS} from '../constants'
import axiosInstance from "../utils/axios.interceptor";

export const listSupportingDocuments = (foldername) => {
  return async (dispatch) => {
    let response = await axiosInstance({
      method: 'POST',
      url: '/readsupportingfiles',
      data: { "foldername":foldername}
    });
    //This is to trigger componentWillReceiveProps()
    response.timestamp = new Date().toLocaleString();
    dispatch({type:SUPPORTINGDOCUMENTS,payload:response.data});
  };
};
